import { Button, Divider, Flex, Form, Input, Space } from "antd";
import { PlusCircle, Trash2 } from "lucide-react";
import { useTranslation } from "react-i18next";

export const ConnectingQuestion = () => {
  const {t} = useTranslation();
  return (
    <>
      <Form.List name={["answers"]} initialValue={[{}]}>
        {(fields, { add, remove }) => (
          <div style={{ width: "100%" }}>
            {fields.map(({ key, name, ...restField }) => {
              return (
                <div key={key}>
                  <Divider orientation="left">
                    {`${t("forms.questions.pairedAnswer")} ${name + 1}`}{" "}
                  </Divider>
                  <Space
                    direction="horizontal"
                    className="connection-question-type"
                    key={key}
                    style={{
                      display: "flex",
                      marginBottom: 8,
                      alignItems: "center",
                    }}
                    align="baseline"
                  >
                    <Space direction="vertical" style={{ width: "100%" }}>
                      <Form.Item
                        noStyle
                        {...restField}
                        name={[name, "value"]}
                        rules={[
                          {
                            required: true,
                            message: t("forms.questions.textRequired"),
                          }                          
                        ]}
                      >
                        <Input placeholder={`${t("forms.questions.option")} ${name + 1}`} />
                      </Form.Item>

                      <Form.Item
                        noStyle
                        style={{ width: "100%" }}
                        {...restField}
                        name={[name, "pairAnswerText"]}
                        rules={[
                          {
                            required: true,
                            message: t("forms.questions.textRequired"),
                          }
                        ]}
                      >
                        <Input
                          placeholder={`${t("forms.questions.pairOption")} ${name + 1}`}
                        />
                      </Form.Item>
                      {/* <Form.Item hidden noStyle name={[name, "isCorrect"]} initialValue={true}/> */}
                    </Space>
                    <Flex align="center">
                      <Button
                        icon={<Trash2 />}
                        danger
                        onClick={() => remove(name)}
                      />
                    </Flex>
                  </Space>
                </div>
              );
            })}
            <Form.Item noStyle>
              <Button
                type="dashed"
                icon={<PlusCircle />}
                block
                onClick={() => add()}
              >
                {t("forms.questions.addAnswer")}
              </Button>
            </Form.Item>
          </div>
        )}
      </Form.List>
    </>
  );
};
